/**
 * @enum
 * @readonly
 */
export const ColorId = Object.freeze({
  TRANSLUCENT: 1,
  WHITE: 2,
  YELLOW: 3,
  ORANGE: 4,
  RED: 5,
  PINK: 6,
  GREEN: 7,
  BLUE: 8,
  BLACK: 9,
});

/**
 *
 * @type {ColorId}
 */
export const DEFAULT_COLOR_ID = ColorId.TRANSLUCENT;

export const GENERIC_COLORS = [ColorId.TRANSLUCENT, ColorId.WHITE];

export default {
  // Translucide
  [ColorId.TRANSLUCENT]: {
    value: '#ddd',
    previewValue: 'rgba(224, 224, 224, 0.5)',
    materialOpacity: 0.9,
  },
  // Blanc
  [ColorId.WHITE]: {
    value: '#ddd',
    previewValue: '#fff',
    materialOpacity: 1,
  },
  // Jaune
  [ColorId.YELLOW]: {
    value: '#ffc846',
    previewValue: null,
    materialOpacity: 1,
  },
  // Orange
  [ColorId.ORANGE]: {
    value: '#ff880b',
    previewValue: null,
    materialOpacity: 1,
  },
  // Rouge
  [ColorId.RED]: {
    value: '#ff2f31',
    previewValue: null,
    materialOpacity: 1,
  },
  // Rose
  [ColorId.PINK]: {
    value: '#ff9de0',
    previewValue: null,
    materialOpacity: 1,
  },
  // Vert
  [ColorId.GREEN]: {
    value: '#0b9b07',
    previewValue: null,
    materialOpacity: 1,
  },
  // Bleu
  [ColorId.BLUE]: {
    value: '#287bde',
    previewValue: null,
    materialOpacity: 1,
  },
  // Black
  [ColorId.BLACK]: {
    value: '#000',
    previewValue: '#fff',
    materialOpacity: 1,
  },
};
